import { render, staticRenderFns } from "./dataReview.vue?vue&type=template&id=0444bebf&scoped=true&"
import script from "./dataReview.vue?vue&type=script&lang=js&"
export * from "./dataReview.vue?vue&type=script&lang=js&"
import style0 from "./dataReview.vue?vue&type=style&index=0&id=0444bebf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444bebf",
  null
  
)

export default component.exports